"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _StepTrackerContext = _interopRequireDefault(require("./StepTrackerContext"));
var _constants = require("../constants");
var _analyticsUtils = require("../utils/analyticsUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var {
  RADIOBUTTON_FIELD,
  CHECKBOX_FIELD,
  DROPDOWNLIST_FIELD
} = _constants.FIELD_TYPES;
var isFieldGroup = field => field.type === _constants.FIELD_TYPES.FIELD_GROUP_FIELD;
var isRichTextField = field => field.type === _constants.FIELD_TYPES.RICH_TEXT_FIELD;
var isConditionalField = field => {
  var isConditionalFieldType = false;
  // Check if field type can be one of the 3 possible that can have conditional fields
  if (field.type === RADIOBUTTON_FIELD || field.type === CHECKBOX_FIELD || DROPDOWNLIST_FIELD) {
    // Check if the field has conditionalFieldGroup data
    if (Array.isArray(field === null || field === void 0 ? void 0 : field.options)) {
      field.options.forEach(option => {
        var _option$conditionalFi;
        if (Array.isArray(option === null || option === void 0 || (_option$conditionalFi = option.conditionalFieldGroup) === null || _option$conditionalFi === void 0 ? void 0 : _option$conditionalFi.fields)) {
          isConditionalFieldType = true;
        }
      });
    }
  }
  return isConditionalFieldType;
};
var isStepValid = function isStepValid() {
  var currentStepIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fieldData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    current: {}
  };
  var result = currentStepIds.reduce((prev, current) => {
    var _fieldData$current$cu, _fieldData$current$cu2;
    return prev && ((fieldData === null || fieldData === void 0 || (_fieldData$current$cu = fieldData.current[current]) === null || _fieldData$current$cu === void 0 ? void 0 : _fieldData$current$cu.isValid) || (fieldData === null || fieldData === void 0 || (_fieldData$current$cu2 = fieldData.current[current]) === null || _fieldData$current$cu2 === void 0 ? void 0 : _fieldData$current$cu2.isHidden));
  }, true);
  return result;
};
var StepTrackerProvider = _ref => {
  var _steps$currentStep, _steps$currentStep2;
  var {
    steps,
    fieldReferences,
    fieldData,
    formMetaData,
    children
  } = _ref;
  var stepTrackerDisplayRef = (0, _react.useRef)(null);
  var [currentStep, setCurrentStep] = (0, _react.useState)(0);
  var [buttonControlPressed, setButtonControlPressed] = (0, _react.useState)(false);
  var [disableBackButton, setDisableBackButton] = (0, _react.useState)(true);
  var [showSubmitButton, setShowSubmitButton] = (0, _react.useState)(false);
  var currentStepIds = [];
  (_steps$currentStep = steps[currentStep]) === null || _steps$currentStep === void 0 || _steps$currentStep.fields.forEach(field => {
    if (isFieldGroup(field) && field.fields && Array.isArray(field.fields)) {
      field.fields.forEach(childField => {
        if (!isRichTextField(childField)) {
          currentStepIds.push(childField.id);
        }
      });
    } else if (isConditionalField(field) && field.options && Array.isArray(field === null || field === void 0 ? void 0 : field.options)) {
      currentStepIds.push(field.id);
      field.options.forEach(option => {
        var _option$conditionalFi2;
        (_option$conditionalFi2 = option.conditionalFieldGroup) === null || _option$conditionalFi2 === void 0 || _option$conditionalFi2.fields.forEach(childField => {
          if (!isRichTextField(childField)) {
            currentStepIds.push(childField.id);
          }
        });
      });
    } else if (!isRichTextField(field)) {
      currentStepIds.push(field.id);
    }
  });
  var currentStepReferences = [];
  (_steps$currentStep2 = steps[currentStep]) === null || _steps$currentStep2 === void 0 || _steps$currentStep2.fields.forEach(field => {
    if (isFieldGroup(field) && field.fields && Array.isArray(field.fields)) {
      field.fields.forEach(childField => {
        if (!isRichTextField(childField)) {
          currentStepReferences.push(fieldReferences[childField.id]);
        }
      });
    } else if (isConditionalField(field) && field.options && Array.isArray(field === null || field === void 0 ? void 0 : field.options)) {
      currentStepReferences.push(fieldReferences[field.id]);
      field.options.forEach(option => {
        var _option$conditionalFi3;
        (_option$conditionalFi3 = option.conditionalFieldGroup) === null || _option$conditionalFi3 === void 0 || _option$conditionalFi3.fields.forEach(childField => {
          if (!isRichTextField(childField)) {
            currentStepReferences.push(fieldReferences[childField.id]);
          }
        });
      });
    } else if (!isRichTextField(field)) {
      currentStepReferences.push(fieldReferences[field.id]);
    }
  });
  (0, _react.useEffect)(() => {
    setDisableBackButton(currentStep === 0);
    setShowSubmitButton(currentStep === steps.length - 1);
  }, [currentStep, steps.length]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      focusOnStepTracker();
      setButtonControlPressed(false);
    }
  }, [buttonControlPressed]);
  var focusOnStepTracker = () => {
    if (stepTrackerDisplayRef && stepTrackerDisplayRef.current) {
      stepTrackerDisplayRef.current.setAttribute('tabindex', '-1');
      setTimeout(() => {
        stepTrackerDisplayRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    }
  };
  var OnNextStep = () => {
    setButtonControlPressed(true);
    if (!isStepValid(currentStepIds, fieldData) || currentStep === steps.length - 1) {
      return;
    }
    setButtonControlPressed(false);
    setCurrentStep(prevStep => prevStep + 1);
    (0, _analyticsUtils.triggerAnalyticsFormStepEvent)({
      formMetaData,
      currentStep,
      fieldData
    });
  };
  var OnPreviousStep = () => {
    setCurrentStep(prevStep => prevStep - 1);
  };
  return /*#__PURE__*/_react.default.createElement(_StepTrackerContext.default.Provider, {
    value: {
      steps,
      currentStep,
      currentStepReferences,
      disableBackButton,
      showSubmitButton,
      buttonControlPressed,
      stepTrackerDisplayRef,
      OnNextStep,
      OnPreviousStep
    }
  }, children);
};
var _default = exports.default = StepTrackerProvider;